// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Updated styles.css */
.no-daisyui .bg-white {
  background-color: white;
}

/* Increase padding around the content for better spacing */
.no-daisyui .p-8 {
  padding: 48px; /* Increased from 32px */
}

.no-daisyui .mb-4 {
  margin-bottom: 30px;
}

.no-daisyui .text-colour {
  color: white;
}

/* Increase font size for larger headers */
.no-daisyui .text-3xl {
  font-size: 3.5rem; /* Increased from 1.875rem (30px) to 36px */
  line-height: 4rem; /* Increased from 2.25rem (36px) to 44px */
}

.no-daisyui .font-bold-2 {
  font-weight: 1000;
  font-size: 1.5rem;
}

.no-daisyui .font-bold {
  font-weight: 1000;
}

.no-daisyui .thick-font {
  font-weight: 800;
}

.no-daisyui .text-center {
  text-align: center;
}

/* Increase font size for secondary headers */
.no-daisyui .text-2xl {
  font-size: 2.5rem; /* Increased from 1.5rem (24px) to 28px */
  line-height: 3rem; /* Increased from 2rem (32px) to 36px */
}

.no-daisyui .bg-black {
  background-color: black;
}

.no-daisyui .text-white {
  color: white;
}

/* Adjust grid layout for wider content spread */
.no-daisyui .grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* Adjusted for full width utilization */
  gap: 32px; /* Increased gap from 16px for better spacing */
}

/* Increase base text size for better readability */
.no-daisyui .text-xs {
  font-size: 1.75rem; /* Increased from 18px */
  line-height: 2rem; /* Increased from 22px */
}

.no-daisyui .bg-slate-400 {
  background-color: #cbd5e0;
}

/* Increase text size for larger body text */
.no-daisyui .text-lg {
  font-size: 2rem; /* Increased from 1.125rem (18px) to 20px */
  line-height: 2.5rem; /* Increased from 1.75rem (28px) to 32px */
}


.no-daisyui .text-right {
  text-align: right;
}

.no-daisyui .whitespace-nowrap {
  white-space: nowrap;
}

.no-daisyui .justify-center {
  justify-content: center;
}

.no-daisyui .text-center {
  text-align: center;
}

/* Slightly larger than default for subtext */
.no-daisyui .text-sm {
  font-size: 2rem; /* Increased from 1.75rem */
  line-height: 2.05rem; /* Increased from 2rem */
}

.no-daisyui .flex {
  display: flex;
}

.no-daisyui .justify-between {
  justify-content: space-between;
}

.no-daisyui .items-center {
  align-items: center;
}

.no-daisyui .px-4 {
  padding-left: 14px;
  padding-right: 14px;
}

.no-daisyui .py-3 {
  padding-top: 11px;
  padding-bottom: 11px;
}

.no-daisyui .py-2 {
  padding-top: 10px;
  padding-bottom: 12px;
}

.no-daisyui .py-1 {
  padding-top: 7px;
  padding-bottom: 7px;
}

.no-daisyui .main-padding {
  padding-top: 2.5rem;
  padding-bottom: 4rem;
  padding-left: 10rem;
  padding-right: 10rem;
}

.no-daisyui .bg-slate-800 {
  background-color: #1e293b;
}

.no-daisyui .emoji {
  filter: grayscale(100%) brightness(0);
}

.no-daisyui .bg-black {
  background-color: black;
}

/* Ensure all text elements have increased font size */
.no-daisyui h1, .no-daisyui h2, .no-daisyui h3, .no-daisyui p, .no-daisyui span {
  font-size: 30px; /* Set a base font size for consistency */
}

@media (max-width: 768px) {
  .no-daisyui .p-8 { padding: 2px; } /* Reduced padding */
  .no-daisyui .text-3xl { font-size: 0.75rem; line-height: 0.3rem; } /* Significantly reduced font size for large headers */
  .no-daisyui .text-2xl { font-size: 0.75rem; line-height: 0.01rem; } /* Adjusted font size for secondary headers */
  .no-daisyui .text-lg { font-size: 0.4rem; line-height: 0.01rem; } /* Adjusted larger body text size */
  .no-daisyui .text-xs { font-size: 0.35rem; line-height: 0.2rem; } /* Adjusted base text size */
  .no-daisyui .text-sm { font-size: 0.375rem; line-height: 0.01rem; } /* Further reduced smaller text size */
  .no-daisyui .mb-4 { margin-bottom: 2px; }
  .no-daisyui .px-4 { padding-left: 20px; padding-right: 20px; }
  .no-daisyui .py-3, .no-daisyui .py-2, .no-daisyui .py-1 { padding-top: 4px; padding-bottom: 4px; }
  .no-daisyui .btn { padding: 8px 16px; font-size: 0.26rem; } /* Adjusted button styles */
  .no-daisyui .form-input { padding: 8px; font-size: 0.26rem; } /* Adjusted form input styles */
  .no-daisyui .navbar { flex-direction: column; padding: 2px; } /* Adjusted navbar for vertical layout */
  .no-daisyui .nav-link { margin-bottom: 2px; } /* Space between vertical nav links */
  .no-daisyui .modal { width: 90%; margin: 2px; } /* Adjusted modal width */
  .no-daisyui h1, .no-daisyui h2, .no-daisyui h3, .no-daisyui p, .no-daisyui span { font-size: 0.3rem; } /* Uniformly reduced base font size for smaller screens */
  .no-daisyui .phone-padding {padding-left: 2rem; padding-right: 2rem;}
}

@media print {
  .container {
    width: 794px; /* Approximate conversion of A4 width to pixels */
    max-width: 100%;
  }

  /* Adjust font sizes and other elements as needed for print */
  h1, h2, h3, p, .your-class {
    font-size: 10pt; /* Example to adjust font sizes for print */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/receipt.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,uBAAuB;AACzB;;AAEA,2DAA2D;AAC3D;EACE,aAAa,EAAE,wBAAwB;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA,0CAA0C;AAC1C;EACE,iBAAiB,EAAE,2CAA2C;EAC9D,iBAAiB,EAAE,0CAA0C;AAC/D;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,6CAA6C;AAC7C;EACE,iBAAiB,EAAE,yCAAyC;EAC5D,iBAAiB,EAAE,uCAAuC;AAC5D;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,qCAAqC,EAAE,wCAAwC;EAC/E,SAAS,EAAE,+CAA+C;AAC5D;;AAEA,mDAAmD;AACnD;EACE,kBAAkB,EAAE,wBAAwB;EAC5C,iBAAiB,EAAE,wBAAwB;AAC7C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4CAA4C;AAC5C;EACE,eAAe,EAAE,2CAA2C;EAC5D,mBAAmB,EAAE,0CAA0C;AACjE;;;AAGA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,6CAA6C;AAC7C;EACE,eAAe,EAAE,2BAA2B;EAC5C,oBAAoB,EAAE,wBAAwB;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;AACzB;;AAEA,sDAAsD;AACtD;EACE,eAAe,EAAE,yCAAyC;AAC5D;;AAEA;EACE,mBAAmB,YAAY,EAAE,EAAE,oBAAoB;EACvD,wBAAwB,kBAAkB,EAAE,mBAAmB,EAAE,EAAE,sDAAsD;EACzH,wBAAwB,kBAAkB,EAAE,oBAAoB,EAAE,EAAE,6CAA6C;EACjH,uBAAuB,iBAAiB,EAAE,oBAAoB,EAAE,EAAE,mCAAmC;EACrG,uBAAuB,kBAAkB,EAAE,mBAAmB,EAAE,EAAE,4BAA4B;EAC9F,uBAAuB,mBAAmB,EAAE,oBAAoB,EAAE,EAAE,sCAAsC;EAC1G,oBAAoB,kBAAkB,EAAE;EACxC,oBAAoB,kBAAkB,EAAE,mBAAmB,EAAE;EAC7D,0DAA0D,gBAAgB,EAAE,mBAAmB,EAAE;EACjG,mBAAmB,iBAAiB,EAAE,kBAAkB,EAAE,EAAE,2BAA2B;EACvF,0BAA0B,YAAY,EAAE,kBAAkB,EAAE,EAAE,+BAA+B;EAC7F,sBAAsB,sBAAsB,EAAE,YAAY,EAAE,EAAE,wCAAwC;EACtG,wBAAwB,kBAAkB,EAAE,EAAE,qCAAqC;EACnF,qBAAqB,UAAU,EAAE,WAAW,EAAE,EAAE,yBAAyB;EACzE,kFAAkF,iBAAiB,EAAE,EAAE,yDAAyD;EAChK,4BAA4B,kBAAkB,EAAE,mBAAmB,CAAC;AACtE;;AAEA;EACE;IACE,YAAY,EAAE,iDAAiD;IAC/D,eAAe;EACjB;;EAEA,6DAA6D;EAC7D;IACE,eAAe,EAAE,2CAA2C;EAC9D;AACF","sourcesContent":["/* Updated styles.css */\n.no-daisyui .bg-white {\n  background-color: white;\n}\n\n/* Increase padding around the content for better spacing */\n.no-daisyui .p-8 {\n  padding: 48px; /* Increased from 32px */\n}\n\n.no-daisyui .mb-4 {\n  margin-bottom: 30px;\n}\n\n.no-daisyui .text-colour {\n  color: white;\n}\n\n/* Increase font size for larger headers */\n.no-daisyui .text-3xl {\n  font-size: 3.5rem; /* Increased from 1.875rem (30px) to 36px */\n  line-height: 4rem; /* Increased from 2.25rem (36px) to 44px */\n}\n\n.no-daisyui .font-bold-2 {\n  font-weight: 1000;\n  font-size: 1.5rem;\n}\n\n.no-daisyui .font-bold {\n  font-weight: 1000;\n}\n\n.no-daisyui .thick-font {\n  font-weight: 800;\n}\n\n.no-daisyui .text-center {\n  text-align: center;\n}\n\n/* Increase font size for secondary headers */\n.no-daisyui .text-2xl {\n  font-size: 2.5rem; /* Increased from 1.5rem (24px) to 28px */\n  line-height: 3rem; /* Increased from 2rem (32px) to 36px */\n}\n\n.no-daisyui .bg-black {\n  background-color: black;\n}\n\n.no-daisyui .text-white {\n  color: white;\n}\n\n/* Adjust grid layout for wider content spread */\n.no-daisyui .grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr); /* Adjusted for full width utilization */\n  gap: 32px; /* Increased gap from 16px for better spacing */\n}\n\n/* Increase base text size for better readability */\n.no-daisyui .text-xs {\n  font-size: 1.75rem; /* Increased from 18px */\n  line-height: 2rem; /* Increased from 22px */\n}\n\n.no-daisyui .bg-slate-400 {\n  background-color: #cbd5e0;\n}\n\n/* Increase text size for larger body text */\n.no-daisyui .text-lg {\n  font-size: 2rem; /* Increased from 1.125rem (18px) to 20px */\n  line-height: 2.5rem; /* Increased from 1.75rem (28px) to 32px */\n}\n\n\n.no-daisyui .text-right {\n  text-align: right;\n}\n\n.no-daisyui .whitespace-nowrap {\n  white-space: nowrap;\n}\n\n.no-daisyui .justify-center {\n  justify-content: center;\n}\n\n.no-daisyui .text-center {\n  text-align: center;\n}\n\n/* Slightly larger than default for subtext */\n.no-daisyui .text-sm {\n  font-size: 2rem; /* Increased from 1.75rem */\n  line-height: 2.05rem; /* Increased from 2rem */\n}\n\n.no-daisyui .flex {\n  display: flex;\n}\n\n.no-daisyui .justify-between {\n  justify-content: space-between;\n}\n\n.no-daisyui .items-center {\n  align-items: center;\n}\n\n.no-daisyui .px-4 {\n  padding-left: 14px;\n  padding-right: 14px;\n}\n\n.no-daisyui .py-3 {\n  padding-top: 11px;\n  padding-bottom: 11px;\n}\n\n.no-daisyui .py-2 {\n  padding-top: 10px;\n  padding-bottom: 12px;\n}\n\n.no-daisyui .py-1 {\n  padding-top: 7px;\n  padding-bottom: 7px;\n}\n\n.no-daisyui .main-padding {\n  padding-top: 2.5rem;\n  padding-bottom: 4rem;\n  padding-left: 10rem;\n  padding-right: 10rem;\n}\n\n.no-daisyui .bg-slate-800 {\n  background-color: #1e293b;\n}\n\n.no-daisyui .emoji {\n  filter: grayscale(100%) brightness(0);\n}\n\n.no-daisyui .bg-black {\n  background-color: black;\n}\n\n/* Ensure all text elements have increased font size */\n.no-daisyui h1, .no-daisyui h2, .no-daisyui h3, .no-daisyui p, .no-daisyui span {\n  font-size: 30px; /* Set a base font size for consistency */\n}\n\n@media (max-width: 768px) {\n  .no-daisyui .p-8 { padding: 2px; } /* Reduced padding */\n  .no-daisyui .text-3xl { font-size: 0.75rem; line-height: 0.3rem; } /* Significantly reduced font size for large headers */\n  .no-daisyui .text-2xl { font-size: 0.75rem; line-height: 0.01rem; } /* Adjusted font size for secondary headers */\n  .no-daisyui .text-lg { font-size: 0.4rem; line-height: 0.01rem; } /* Adjusted larger body text size */\n  .no-daisyui .text-xs { font-size: 0.35rem; line-height: 0.2rem; } /* Adjusted base text size */\n  .no-daisyui .text-sm { font-size: 0.375rem; line-height: 0.01rem; } /* Further reduced smaller text size */\n  .no-daisyui .mb-4 { margin-bottom: 2px; }\n  .no-daisyui .px-4 { padding-left: 20px; padding-right: 20px; }\n  .no-daisyui .py-3, .no-daisyui .py-2, .no-daisyui .py-1 { padding-top: 4px; padding-bottom: 4px; }\n  .no-daisyui .btn { padding: 8px 16px; font-size: 0.26rem; } /* Adjusted button styles */\n  .no-daisyui .form-input { padding: 8px; font-size: 0.26rem; } /* Adjusted form input styles */\n  .no-daisyui .navbar { flex-direction: column; padding: 2px; } /* Adjusted navbar for vertical layout */\n  .no-daisyui .nav-link { margin-bottom: 2px; } /* Space between vertical nav links */\n  .no-daisyui .modal { width: 90%; margin: 2px; } /* Adjusted modal width */\n  .no-daisyui h1, .no-daisyui h2, .no-daisyui h3, .no-daisyui p, .no-daisyui span { font-size: 0.3rem; } /* Uniformly reduced base font size for smaller screens */\n  .no-daisyui .phone-padding {padding-left: 2rem; padding-right: 2rem;}\n}\n\n@media print {\n  .container {\n    width: 794px; /* Approximate conversion of A4 width to pixels */\n    max-width: 100%;\n  }\n\n  /* Adjust font sizes and other elements as needed for print */\n  h1, h2, h3, p, .your-class {\n    font-size: 10pt; /* Example to adjust font sizes for print */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
